import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Bloque l'accès direct par URL à une page pour laquelle le compte connecté n'a pas
 * le droit requis (un super-admin passe toujours, cf. AuthService.hasPermission).
 * Complète le filtrage du menu dans ShellComponent, qui ne fait que masquer le lien.
 */
export const permissionGuard = (permission: string): CanActivateFn => () => {
  if (!isPlatformBrowser(inject(PLATFORM_ID))) return true;
  const auth = inject(AuthService);
  const router = inject(Router);
  if (auth.hasPermission(permission)) return true;
  return router.createUrlTree(['/dashboard'], { queryParams: { accessDenied: permission } });
};
